<!-- @format -->
<template>
  <div class="top-header">
    <div class="top-header__wrapper">
      <div class="top-header__trigger-wrapper" @click="openMenu">
        <img
          :src="
            !open
              ? require(`@/assets/images/navigation/hamburger.png`)
              : require(`@/assets/images/navigation/close.png`)
          "
          alt=""
        />
      </div>
    </div>
    <div id="top_nav" class="offcanvas-bar" :class="{ 'show-offcanvas': open }">
      <div class="offcanvas-bar__wrapper" :class="$mq">
        <div
          v-for="(value, key) in this.$config.navigation"
          :key="value.sitename"
        >
          <!-- eslint-disable-next-line vue/require-v-for-key -->
          <a
            class="nav-item"
            :class="$mq"
            v-scroll-to="{ el: '.desktop-' + value.sitename, offset: -55 }"
            @click="closeMenu()"
          >
            {{ key }}
          </a>
        </div>

        <div class="nav-share-top">
          <div class="offcanvas-bar__kinofinder" :class="$mq">
            <div
              :href="$config.kinoservice.finder + $config.kinoservice.slug"
              target="_blank"
              class="nav-item kino-zeit"
              :class="$mq"
              @click="open_de_kinofinder"
            >
              Kinofinder
            </div>
          </div>
          <div class="offcanvas-bar__kinofinder" :class="$mq">
            <div
              href="https://www.falter.at/kino/921345/wagner-bayreuth-und-der-rest-der-welt?date=2022-02-12&region=kärnten"
              target="_blank"
              class="nav-item kino-zeit"
              :class="$mq"
              @click="open_de_kinofinder"
            >
              Kinofinder Österreich
            </div>
          </div>
          <div class="offcanvas-bar__filmwecker" :class="$mq">
            <div
              target="_blank"
              class="nav-item kino-zeit"
              @click="open_de_filmwecker"
              :class="$mq"
            >
              Filmwecker
            </div>
          </div>
        </div>
        <div class="bottom-nav">
          <component class="nav" :is="companyNav"></component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { EventBus } from '@/plugins/event-bus.js'

export default {
  props: {
    social: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: false,
    }
  },
  computed: {
    companyNav() {
      return () =>
        import(
          `@/website_elements/global/companies/${this.$config.verantwortlich.toLowerCase()}/FooterNav.vue`
        )
    },
  },
  created() {
    /* eslint-disable-next-line no-undef */
    EventBus.$on(
      'close-all_menus',
      function () {
        this.open = !this.open
      }.bind(this)
    )
  },
  methods: {
    open_de_kinofinder() {
      window.open(`https://www.kino.de/film/${this.$config.kinoservice.slug}/`)
    },
    open_de_filmwecker() {
      window.open(
        `https://www.kino-zeit.de/alert/${this.$config.kinoservice.id}`
      )
    },
    openMenu() {
      this.open = !this.open
      EventBus.$emit('close-expandables')
    },
    closeMenu() {
      this.open = !this.open
    },
  },
}
</script>

<style lang="scss">
.top-header {
  $self: &;
  position: relative;

  &__wrapper {
    position: relative;
    width: 50px;
    height: 36px;
    position: fixed;
    left: 10px;
    top: 10px;
    color: black;
    z-index: 9999999999;
  }
}
.show-offcanvas {
  opacity: 1 !important;
  -webkit-transform: translateX(0) !important;
  transform: translateX(0) !important;
}
.offcanvas-bar {
  $self: &;
  opacity: 0;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  width: 100%;
  transform: translateY(-100%);
  -webkit-transition: -webkit-transform 0.6s ease-out;
  transition: transform 0.6s ease-out;
  z-index: 200;
  &__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100%;
    /* $min_width: 1024px;
    $max_width: 2560px;
    $min_font: 40px;
    $max_font: 80px;
    @include fluid-type($min_width, $max_width, $min_font, $max_font); */

    &.sm {
      font-size: 1.5rem;
    }
    .nav-item {
      position: relative;
      cursor: pointer;
      text-transform: uppercase;
      font-weight: 900;
      margin: 10px 0;
      color: black;
      font-size: clamp(2.5rem, 3vw, 5rem);
      &.sm {
        margin: 5px 0;
      }
      &:hover {
        color: var(--clr-red);
      }
    }
    .nav-share-top {
      display: flex;
      flex-direction: row;
      justify-content: center;
      margin-top: 10px;
      .kino-zeit {
        background-color: black;
        color: white;
        padding-inline: 20px;
        &:hover {
          background-color: var(--clr-red);
        }
      }
      #{$self}__kinofinder {
        position: relative;
        text-align: left;
        padding-right: 10px;
      }
      #{$self}__filmwecker {
        position: relative;
        text-align: left;
        padding-left: 10px;
      }
    }

    .bottom-nav {
      .filmwelt-nav {
        $self: &;
        display: flex;
        height: 50px;
        flex-direction: row;
        font-weight: 700;
        margin-top: 70px;
        justify-content: center;
        text-transform: uppercase;
        font-size: 1rem;
        a {
          color: black;
          text-decoration: none;
          &:hover {
            color: var(--clr-red);
          }
          &:not(:last-child):after {
            color: black;
            content: '|';
            padding: 0 5px 0 5px;
          }
        }
        &.sm {
          background-color: white;
          a {
            &:after {
              content: '';
            }
            &:last-child {
              margin-left: 0;
            }
          }
        }
        &.md,
        &.lg,
        &.xl,
        &.xxl {
          flex-direction: row;
        }
      }
    }
  }
}
@media only screen and (min-width: 600px) {
  .navTrigger {
    transform: translateX(50%) translateY(50%) scale(2);
  }
}
</style>
